import React, { useState } from "react"

function SecretCell(props){

    const {secret} = props;
    const [visible, setVisible] = useState(false)
    const invisiblePlaceholder = "●●●●●●●●●●●●"

    return(
        <span style={{display: "grid", gridTemplateColumns: "145px min-content", columnGap: "0.5rem", alignItems: "center"}}>
            <span>{visible? secret : invisiblePlaceholder }</span>
            <div className="display-secret-button" role="button" onMouseDown={()=>setVisible(true)} onMouseLeave={()=>setVisible(false)} onMouseUp={()=>setVisible(false)}>
                    {visible? <i className="icon icon-eye-off"></i> : <i className="icon icon-eye-on"></i>}
            </div>
        </span>
    )
}

export {SecretCell}